
import { useEffect, useState } from "react";
import { useParams ,useNavigate  } from "react-router-dom";
import { useTrackOrderById } from "../../hooks/order/useTrackOrder";
import OrderTrackingWrapper from "../../wrapper/track/OrderTrackingTimeline";
import { ORDER_DETAIL_BUTTON } from "../../data/track/trackDetailButtons";
import AdvancedTable from "../../components/table/ResponsiveTable";
import dayjs from "dayjs";
import { FiArrowLeft } from "react-icons/fi";

import {
    Package,
    Layers3,
    Hash,
    ShoppingBag,
    Truck,
    ChevronDown,
    ChevronUp,
    Tag,
    CircleDollarSign,
    CheckCircle2,
} from "lucide-react";
import { getImage } from "../../../utils/mediaUtils/mediaUtils";

const OrderItemsView = ({ items = [] }) => {

    const [expandedCombos, setExpandedCombos] = useState({});

    /*
     * Group order items
     *
     * Combo items:
     * comboId + comboName
     *
     * Normal products:
     * individual item
     */
    const groupedItems = items.reduce((groups, item) => {

        console.log(items, "itemsingrouping")

        if (item.inCombo && item.comboId) {

            const key = `combo-${item.comboId}`;

            if (!groups[key]) {
                groups[key] = {
                    type: "combo",
                    comboId: item.comboId,
                    comboCode: item.comboCode,
                    comboName: item.comboName,
                    comboPrice: Number(item.comboPrice || 0),
                    comboQty: Number(item.comboQty || 1),
                    shippingFee: Number(item.shippingFee || 0),
                    items: [],
                };
            }

            groups[key].items.push(item);

        } else {

            const key = `product-${item.id}`;

            groups[key] = {
                type: "product",
                items: [item],
            };
        }

        return groups;

    }, {});

    const groupedData = Object.values(groupedItems);

    const toggleCombo = (comboId) => {
        setExpandedCombos(prev => ({
            ...prev,
            [comboId]: !prev[comboId],
        }));
    };

    if (!items.length) {
        return (
            <div className="p-8 text-center text-sm text-gray-400">
                No order items found
            </div>
        );
    }

    return (
        <div className="space-y-3 p-2 sm:p-3">

            {groupedData.map((group, index) => {

                console.log(group , "group details")

                if (group.type === "combo") {

                    const combo = group;

                    const isExpanded =
                        expandedCombos[combo.comboId] ?? true;

                    const productTotal = combo.items.reduce(
                        (sum, item) =>
                            sum + Number(item.price || 0),
                        0
                    );

                    return (
                        <div
                            key={`combo-${combo.comboId}`}
                            className="
                                overflow-hidden
                                rounded-xl
                                border
                                border-[#e7ddd2]
                                bg-white
                                shadow-[0_5px_25px_rgba(70,50,30,0.06)]
                            "
                        >

                            {/* =====================================================
                                COMBO HEADER
                            ====================================================== */}

                            <div
                                className="
                                    relative
                                    overflow-hidden
                                    bg-gradient-to-r
                                    from-[#faf6f1]
                                    via-[#fffdfb]
                                    to-[#f3e9dd]
                                    p-2
                                    sm:p-3
                                "
                            >

                                <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-[#b08d57]/10 blur-2xl" />

                                <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">

                                    {/* Left */}
                                    <div className="flex items-start gap-3">

                                        <div
                                            className="
                                                flex
                                                h-11
                                                w-11
                                                shrink-0
                                                items-center
                                                justify-center
                                                rounded-xl
                                                bg-[#b08d57]/10
                                                text-[#a17b48]
                                            "
                                        >
                                            <Layers3 className="h-5 w-5" />
                                        </div>

                                        <div>

                                            <div className="mb-1 flex flex-wrap items-center gap-2">

                                                <span
                                                    className="
                                                        rounded-full
                                                        bg-[#b08d57]
                                                        px-2
                                                        py-1
                                                        text-[9px]
                                                        font-bold
                                                        uppercase
                                                        tracking-wider
                                                        text-white
                                                    "
                                                >
                                                    Combo
                                                </span>

                                                <span className="text-[10px] text-gray-400">
                                                    Combo #{combo.comboCode}
                                                </span>

                                            </div>

                                            <h3
                                                className="
                                                    text-base
                                                    font-bold
                                                    text-[#342c26]
                                                    sm:text-lg
                                                "
                                            >
                                                {combo.comboName}
                                            </h3>

                                            <p className="mt-1 text-xs text-gray-500">
                                                {combo.items.length}{" "}
                                                {combo.items.length === 1
                                                    ? "product"
                                                    : "products"}{" "}
                                                included
                                            </p>

                                        </div>
                                    </div>

                                    {/* Right */}
                                    <div className="flex items-center justify-between gap-4 sm:justify-end">

                                        <div className="text-right">

                                            <p className="text-[9px] font-semibold uppercase tracking-wider text-gray-400">
                                                Combo Price
                                            </p>

                                            <p className="text-xl font-bold text-[#a3753d]">
                                                ₹
                                                {combo.comboPrice.toLocaleString(
                                                    "en-IN",
                                                    {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                            </p>

                                        </div>

                                        <button
                                            type="button"
                                            onClick={() =>
                                                toggleCombo(combo.comboId)
                                            }
                                            className="
                                                flex
                                                h-9
                                                w-9
                                                items-center
                                                justify-center
                                                rounded-full
                                                border
                                                border-[#e4d6c7]
                                                bg-white
                                                text-[#806341]
                                                shadow-sm
                                                transition
                                                hover:bg-[#f7f0e8]
                                            "
                                        >
                                            {isExpanded ? (
                                                <ChevronUp className="h-4 w-4" />
                                            ) : (
                                                <ChevronDown className="h-4 w-4" />
                                            )}
                                        </button>

                                    </div>

                                </div>
                            </div>

                            {/* =====================================================
                                COMBO CONTENT
                            ====================================================== */}

                            {isExpanded && (
                                <div className="p-2 sm:p-3">

                                    {/* Products */}
                                    <div
                                        className={`
                                            grid
                                            gap-4
                                            ${combo.items.length === 1
                                                ? "grid-cols-1"
                                                : "grid-cols-1 md:grid-cols-2"
                                            }
                                        `}
                                    >

                                        {combo.items.map((item, itemIndex) => (

                                            <OrderComboItem
                                                key={item.id || itemIndex}
                                                item={item}
                                                index={itemIndex}
                                            />

                                        ))}

                                    </div>

                                    {/* =================================================
                                        COMBO FOOTER
                                    ================================================== */}

                                    <div
                                        className="
                                            mt-2
                                            rounded-xl
                                            border
                                            border-[#eee3d8]
                                            bg-[#fcfaf7]
                                            p-2
                                        "
                                    >

                                        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">

                                            <SummaryBox
                                                icon={Package}
                                                label="Products"
                                                value={combo.items.length}
                                            />

                                            <SummaryBox
                                                icon={Hash}
                                                label="Combo Qty"
                                                value={combo.comboQty}
                                            />

                                            <SummaryBox
                                                icon={Truck}
                                                label="Shipping"
                                                value={`₹${combo.shippingFee.toFixed(2)}`}
                                            />

                                            <SummaryBox
                                                icon={CircleDollarSign}
                                                label="Combo Total"
                                                value={`₹${combo.comboPrice.toLocaleString(
                                                    "en-IN",
                                                    {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}`}
                                                highlight
                                            />

                                        </div>

                                    </div>

                                </div>
                            )}

                        </div>
                    );
                }

                /* =========================================================
                   NORMAL SINGLE PRODUCT
                ========================================================== */

                const item = group.items[0];

                return (
                    <OrderSingleItem
                        key={`single-${item.id || index}`}
                        item={item}
                    />
                );
            })}
        </div>
    );
};
const OrderComboItem = ({ item, index }) => {

    const price = Number(item.price || 0);

    return (
        <div
            className="
                group
                overflow-hidden
                rounded-xl
                border
                border-[#eee5dc]
                bg-white
                transition-all
                duration-300
                hover:border-[#d7bd98]
                hover:shadow-[0_8px_30px_rgba(80,50,20,0.07)]
            "
        >

            <div className="flex gap-4 p-3 sm:p-4">

                {/* Image */}
                <div
                    className="
                        relative
                        h-24
                        w-24
                        shrink-0
                        overflow-hidden
                        rounded-xl
                        bg-[#f8f4ef]
                        sm:h-32
                        sm:w-32
                    "
                >

                    <img
                        src={getImage(item.image_path)}
                        alt={ item.productName}
                        className="
                            h-full
                            w-full
                            object-contain
                            
                            transition-transform
                            duration-500
                            group-hover:scale-105
                        "
                    />

                    <span
                        className="
                            absolute
                            left-2
                            top-2
                            flex
                            h-6
                            w-6
                            items-center
                            justify-center
                            rounded-full
                            bg-white/95
                            text-[9px]
                            font-bold
                            text-[#85653f]
                            shadow
                        "
                    >
                        {index + 1}
                    </span>
                </div>

                {/* Details */}
                <div className="min-w-0 m-0  flex-1">

                    <div className="flex items-start justify-between gap-2">

                        <div>

                            <p className="text-[10px] m-0 font-bold uppercase tracking-wider text-primary">
                                Combo Product
                            </p>

                            <h4
                                className="
                                    mt-1
                                    text-sm
                                    font-bold
                                    leading-snug
                                    text-[#302923]
                                    sm:text-base
                                "
                            >
                                {item.productName}
                            </h4>

                        </div>

                        <CheckCircle2
                            className="
                                h-4
                                w-4
                                shrink-0
                                text-emerald-500
                            "
                        />

                    </div>

                    {/* Product Code */}
                    <div className="m-0 flex flex-wrap gap-2">

                        <span
                            className="
                                rounded-md
                                bg-[#f8f4ef]
                                px-2
                                py-1
                                text-[9px]
                                text-gray-500
                            "
                        >
                            Item {item.itemid}
                        </span>

                        <span
                            className="
                                rounded-md
                                bg-[#f8f4ef]
                                px-2
                                py-1
                                text-[9px]
                                text-gray-500
                                m-0
                            "
                        >
                            Tag {item.tagno}
                        </span>

                        <span
                            className="
                                rounded-md
                                bg-[#f8f4ef]
                                px-2
                                py-1
                                text-[9px]
                                text-gray-500
                                m-0
                            "
                        >
                            Qty {item.quantity}
                        </span>

                    </div>

                    {/* Price */}
                    <div className="flex items-end justify-between gap-3 mt-4">

                        <div >

                            <p className="text-[9px] m-0 uppercase tracking-wider text-gray-400">
                                Product Value
                            </p>

                            <p className="m-0 text-base font-bold text-[#9d713d]">
                                ₹
                                {price.toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}
                            </p>

                        </div>

                        {item.shippingFee > 0 && (
                            <span className="text-[9px] text-gray-400">
                                Shipping ₹
                                {Number(item.shippingFee).toFixed(2)}
                            </span>
                        )}

                    </div>

                </div>
            </div>

            {/* Bottom info */}
            <div
                className="
                    grid
                    grid-cols-2
                    border-t
                    border-[#f0e8df]
                    bg-[#fcfaf8]
                    sm:grid-cols-4
                    m-0
                "
            >

                <MiniInfo
                    label="Item ID"
                    value={`${item.itemid}`}
                />

                <MiniInfo
                    label="Tag No"
                    value={item.tagno}
                />

                <MiniInfo
                    label="Serial No"
                    value={item.sno}
                />

                <MiniInfo
                    label="Quantity"
                    value={item.quantity}
                />

            </div>

        </div>
    );
};
const OrderSingleItem = ({ item }) => {

    console.log(item , "singleProduct");

    const price = Number(item.price || 0);

    return (
        <div
            className="
                overflow-hidden
                rounded-2xl
                border
                border-gray-200
                bg-white
                p-4
                shadow-sm
            "
        >

            <div className="flex gap-4">

                <div
                    className="
                        h-24
                        w-24
                        shrink-0
                        overflow-hidden
                        rounded-xl
                        bg-gray-50
                    "
                >
                    <img
                        src={getImage(item.image_path)}
                        alt={item.productName}
                        className="h-full w-full object-contain p-2"
                    />
                </div>

                <div className="flex-1">

                    <div className="mb-1 flex items-center gap-2">
                        <span className="rounded-full bg-gray-100 px-2 py-1 text-[10px] font-bold uppercase text-gray-500">
                            Product
                        </span>
                    </div>

                    <h4 className="text-sm font-bold text-gray-800 m-0 sm:text-base">
                        {item.productName}
                    </h4>

                    <p className="mt-1 text-xs text-gray-400">
                        Item {item.itemid} • Tag {item.tagno}
                    </p>

                    <div className="mt-3 flex items-end justify-between">

                        <div>
                            <p className="text-[11px] m-0 uppercase tracking-wider text-gray-400">
                                Price
                            </p>

                            <p className="font-bold m-0 text-base text-[#9d713d]">
                                ₹
                                {price.toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}
                            </p>
                        </div>

                        <span className="text-xs text-gray-400">
                            Qty: {item.quantity}
                        </span>

                    </div>

                </div>

            </div>
        </div>
    );
};
const SummaryBox = ({
    icon: Icon,
    label,
    value,
    highlight = false,
}) => (
    <div className=" flex items-center gap-4">

        <div
            className={`
                flex
                h-8
                w-8
                shrink-0
                items-center
                justify-center
                rounded-lg
                ${highlight
                    ? "bg-[#b08d57]/10 text-[#a07843]"
                    : "bg-white text-gray-400"
                }
            `}
        >
            <Icon className="h-4 w-4" />
        </div>

        <div className="min-w-0">

            <p className="text-[9px] m-0 uppercase tracking-wider text-gray-400">
                {label}
            </p>

            <p
                className={`
                    truncate
                    text-xs
                    font-bold
                    m-0 
                    ${highlight
                        ? "text-[#9d713d]"
                        : "text-gray-700"
                    }
                `}
            >
                {value}
            </p>

        </div>
    </div>
);


const MiniInfo = ({ label, value }) => (
    <div className="border-r border-[#eee5dc] px-3 py-2 last:border-r-0">

        <p className="text-[10px] m-0 uppercase tracking-wider text-gray-600">
            {label}
        </p>

        <p className="m-0 truncate text-[12px] font-semibold text-gray-700">
            {value || "-"}
        </p>

    </div>
);
function TrackOrder() {
    const { orderId } = useParams();
    const navigate = useNavigate();

    const [activeView ,setActiveView] = useState('HISTORY');

    const {
        data,
        isLoading,
        isError,
        refetch,
    } = useTrackOrderById(orderId);

   const handleViewChange = (viewKey) => {
        setActiveView(viewKey);
    };

    console.log(data ,'order tracking')
    useEffect(() => {
        if (!orderId) {
            navigate("/orders", { replace: true });
        }
    }, [orderId, navigate]);

    const itemHeaderColumn =[

        { key: 'productId', label: 'Product ID' },
        { key:'productName' , label: 'Product Name' },
        { key:'comboName' ,label : 'Combo Name' },
        { key: 'image_path', label: 'Image', align: 'center' },
        { key:'price' , label: 'Price' },
        { key:'shippingFee',label:'Shipping Fee' ,align:'right'},
        { key:'totalAmount',label:'Total Amount' ,align:'right'},
       

    ] ;

    const timelineHeaderColumn = [

        { key: 'status', label: 'Status' },
        
        { key: 'updated_at', label: 'Completed At' },
        { key: 'remarks', label: 'Remark' },

    ];

    const customerAddress = [
        { key:'customerId' , label:'Customer'},
        { key:'phone' , label:'Contact No'},
        {key:'address' , label:'Address'},
        {key:'state' , label:'State'},
    ]




    const renderItemData = (key, item) => {
        switch (key) {
            case "productId":
                return (
                    <span className="text-xs font-medium">
                        {item.itemid}-{item.tagno}
                    </span>
                );

            case "price":
                return (
                    <span className="text-xs">
                        {Number(item.price).toFixed(2)}
                    </span>
                );

            case "image_path":
                return (
                    <div className="flex items-center justify-center">
                        <img
                            src={item.image_path}
                            alt={item.productName}
                            className="w-5 sm:w-10 h-5 sm:h-10 object-cover rounded"
                        />
                    </div>
                   
                );
            
            case 'shippingFee' :
                return(
                    <span className="text-xs">
                        {Number(item.shippingFee).toFixed(2)}
                    </span>
                )

            case 'totalAmount':
                return (
                    <span className="text-xs">
                        {Number(item.totalAmount).toFixed(2)}
                    </span>
                )
            default:
                return (
                    <span className="text-xs">
                        {item[key] ?? "-"}
                    </span>
                );
        }
    };

    const renderTimeLineData = (key , item) =>{
        switch(key){
            case "updated_at":
                return (
                    <span className="text-xs">
                        {item.updated_at
                            ? dayjs(item.updated_at).format("DD MMM YYYY, hh:mm A")
                            : "-"}
                    </span>
                );
            case "status":
                return (
                    <span className="text-xs">
                        {item.status
                            ? item.label
                            : "-"}
                    </span>
                );


            default:
                return (
                    <span className="text-xs">
                        {item[key] ?? " "}
                    </span>
                );
        }
      
    }
const renderCustomerDetails = (key ,item) => {
    switch(key){
        case "customerId":
            return (
                <span className=" flex text-xs gap-2">
                    <span>{item.customerId}</span> - 
                    <span>{item.name}</span>
                </span>
            );
        case "phone":
            return (
                <span className="text-xs">
                    {item.phone}
                </span>
            );
        case "address":
            return (
                <span className="flex flex-col gap-0 text-xs m-0 " >
                    <p className="m-0">{item.addressLine}</p>
                    <p className="m-0" >{item.city}</p>
                    <p className="m-0">{item.pincode}</p>
                    <p className="m-0"> {item.state}</p>
                </span>
            );
        default:
            return (
                <span className="text-xs">
                    {item[key] ?? " "}
                </span>
            );
    }

}
    return(
        <div className="max-w-full m-2 p-2">
            <div className="flex flex-col gap-2">
                <header className="mt-3">
                    <h6 className="flex items-center gap-2 text-xs sm:text-base"><span onClick={()=>navigate(-1)}> <FiArrowLeft /></span> Tracking Details : {orderId} </h6>
                </header>
                <main className="bg-white">
                    <OrderTrackingWrapper currentStatus={data?.current_status} />
                </main>
                <footer className="bg-white border-t">
                    <div className="flex justify-around text-xs sm:text-sm">
                        {ORDER_DETAIL_BUTTON.map(item => (
                            <div
                                key={item.key}
                                onClick={() => setActiveView(item.key)}
                                className={`cursor-pointer px-4 py-3 relative
          ${activeView === item.key
                                        ? "text-[var(--primary-color)] font-medium"
                                        : "text-gray-500"
                                    }
        `}
                            >
                                {item.label}

                                {activeView === item.key && (
                                    <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[var(--primary-color)]" />
                                )}
                            </div>
                        ))}
                    </div>
                    <div>
                        {activeView === "HISTORY" && (
                            <div className="p-3">

                                <AdvancedTable
                                    headers={timelineHeaderColumn}
                                    data={data?.history || []}
                                    fontSizeRow="text-xs"
                                    isLoading={isLoading}
                                    isError={isError}
                                    emptyMessage="No Order Items Found"
                                    renderCell={renderTimeLineData}
                                    onRetry={refetch}
                                    fontSizeHeader="text-sm"
                                    headerText="text-white"
                                    headerBg="bg-[var(--info-color)]"
                                />
                            </div>
                        )}

                        {activeView === "ORDER-DETAIL" && (
                            <OrderItemsView
                                items={data?.items || []}
                            />
                        )}

                        {activeView === "CUSTOMER-DETAIL" && (
                            <>
                            <div className="p-3">

                                {/* Customer Details */}
                                
                                <AdvancedTable
                                    headers={customerAddress}
                                    data={data?.delivery_address? [data?.delivery_address]: [] }
                                    fontSizeRow="text-xs"
                                    isLoading={isLoading}
                                    isError={isError}
                                    emptyMessage="Customer Details Not Found"
                                    renderCell={renderCustomerDetails}
                                    onRetry={refetch}
                                    fontSizeHeader="text-sm"
                                    headerText="text-white"
                                    headerBg="bg-[var(--info-color)]"
                                />
                            </div>
                            </>
                        )}
                    </div>
                </footer>
      
    

            </div>
        </div>
    )
}
export default TrackOrder;